"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _audioVideoDidStartConnectingHandler = require("./audioVideoDidStartConnectingHandler");
Object.keys(_audioVideoDidStartConnectingHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _audioVideoDidStartConnectingHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _audioVideoDidStartConnectingHandler[key];
    }
  });
});